/* eslint-disable no-case-declarations */
import { Select } from "components/Beat/Select"
import DatePicker from "components/EvtKit/date-picker/DatePicker"
import Input from "components/EvtKit/input/Input"
import moment from "moment"
import { useCallback, useMemo } from "react"
import styled from "styled-components"

const ContainerTextInput = styled.div`
  height: 48px;
  width: 100%;
  max-width: 200px;
`

const ContainerDateInput = styled.div`
  height: 48px;
  width: 100%;
  max-width: 418px;
`

const ContainerStatus = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 200px;
`
const SelectStatus = styled(Select)`
  max-height: 48px;
`

interface InputComponentProps {
  column: {
    Header: () => JSX.Element
    accessor: string
    filter?: {
      name: string
      type: string
      label: string
      placeholder?: string
      selectOptions?: { label: string; value: string }[]
    }
  }
  filters: App.AccountFilters | any
  onTextFieldChange: (e: React.ChangeEvent<HTMLInputElement> | { target: { value: string } }) => void
  onDateFilterChange: (filterName, dates: Array<Date | null>) => void
  onSelectChange: (name: string, value: string) => void
}

const InputComponent = ({
  column,
  filters,
  onTextFieldChange,
  onDateFilterChange,
  onSelectChange
}: InputComponentProps) => {
  const inputComponent = useCallback(() => {
    if (column.filter) {
      const selectOption = useMemo(() => {
        if (column.filter) {
          return column.filter.selectOptions ?? []
        } else {
          return []
        }
      }, [column.filter])

      switch (column.filter.type) {
        case "text":
          return (
            <ContainerTextInput>
              <Input
                id={column.accessor}
                type="text"
                name={column.accessor}
                placeholder={column.filter.placeholder}
                onChange={onTextFieldChange}
                value={filters[column.accessor] || ""}
                label={column.filter.label}
                className="filterId"
                shrink
              />
            </ContainerTextInput>
          )

        case "dateText":
          const value = filters[column.accessor]
          const parsedValue = value ? moment(value, "YYYYMMDD").toDate() : undefined

          return (
            <ContainerTextInput>
              <DatePicker
                id={column.accessor}
                dateFormat="dd/MM/yyyy"
                onChange={(date) =>
                  onTextFieldChange({ target: { value: date ? moment(date).format("YYYYMMDD") : "" } })
                }
                startDate={parsedValue}
                selectsRange={false}
                placeholderText={column.filter.placeholder}
                label={column.filter.label}
                shrink
              />
            </ContainerTextInput>
          )

        case "number":
          return (
            <ContainerTextInput>
              <Input
                id={column.accessor}
                type="number"
                name={column.accessor}
                placeholder={column.filter.placeholder}
                onChange={onTextFieldChange}
                value={filters[column.accessor] || ""}
                label={column.filter.label}
                className="filterId"
                shrink
              />
            </ContainerTextInput>
          )

        case "date":
          return (
            <ContainerDateInput>
              <DatePicker
                id={column.accessor}
                dateFormat="dd/MM/yyyy"
                onChange={(dates) =>
                  onDateFilterChange(
                    column.accessor as "processedDate" | "eventDate" | "inviteDate" | "registrationDate",
                    dates as unknown as Array<Date | null>
                  )
                }
                startDate={filters[`${column.accessor}Start`]}
                endDate={filters[`${column.accessor}End`]}
                selectsRange
                placeholderText={column.filter.placeholder}
                label={column.filter.label}
                shrink
              />
            </ContainerDateInput>
          )

        case "select":
          return (
            <ContainerStatus>
              <SelectStatus
                name={column.accessor}
                setValue={(value) => onSelectChange(column.accessor ?? "", value)}
                options={selectOption}
                value={filters[column.accessor] ?? "all"}
                label={column.filter.label}
              />
            </ContainerStatus>
          )

        default:
          return <></>
      }
    } else {
      return <></>
    }
  }, [filters])

  return inputComponent()
}

export default InputComponent
